import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function Sso() {
  return (
    <ScaffoldPage
      title="SSO Configuration"
      description="Configure single sign-on for your organization using SAML or OIDC."
      breadcrumbs={buildBreadcrumbs('/settings/team/sso')}
      plannedFeatures={[
        'SAML 2.0 identity provider integration',
        'OpenID Connect (OIDC) configuration',
        'Automatic user provisioning via SCIM',
        'Domain-based auto-enrollment',
      ]}
      relatedPages={[
        { label: 'Team Members', href: '/settings/team/members' },
        { label: 'Roles & Permissions', href: '/settings/team/roles' },
      ]}
    />
  )
}
